import { render, staticRenderFns } from "./OrdenPagoEmision.vue?vue&type=template&id=6c68506a&scoped=true&"
import script from "./OrdenPagoEmision.vue?vue&type=script&lang=js&"
export * from "./OrdenPagoEmision.vue?vue&type=script&lang=js&"
import style0 from "./OrdenPagoEmision.vue?vue&type=style&index=0&lang=css&"
import style1 from "./OrdenPagoEmision.vue?vue&type=style&index=1&id=6c68506a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c68506a",
  null
  
)

export default component.exports